<div class="p-4">
  <h3 class="text-center">
    {{ 'COMPONENTS.BLOCKS.MODAL_TITLE' | translate }}
  </h3>


  <div class="flex items-center text-center mt-6 font-medium"><div class="w-1/3">{{ 'PIN' | translate }}:</div><div class="w-2/3 py-3 px-16 ml-4 font-semibold rounded-xl text-light-red bg-[var(--tui-base-02)]">{{ data.pin1 }}</div></div>
  <div class="flex items-center text-center mt-6 font-medium"><div class="w-1/3">{{ 'PUK' | translate }}:</div><div class="w-2/3 py-3 px-16 ml-4 font-semibold rounded-xl text-light-red bg-[var(--tui-base-02)]">{{ data.puk1 }}</div></div>
  <div *ngIf="data.pin2 != ''" class="flex items-center text-center mt-6 font-medium"><div class="w-1/3">{{ 'PIN2' | translate }}:</div><div class="w-2/3 py-3 px-16 ml-4 font-semibold rounded-xl text-light-red bg-[var(--tui-base-02)]">{{ data.pin2 }}</div></div>
  <div *ngIf="data.puk2 != ''" class="flex items-center text-center mt-6 font-medium"><div class="w-1/3">{{ 'PUK2' | translate }}:</div><div class="w-2/3 py-3 px-16 ml-4 font-semibold rounded-xl text-light-red bg-[var(--tui-base-02)]">{{ data.puk2 }}</div></div>
  <hr class="my-6" />
  <div class="flex justify-between gap-4">
    <app-button expand="full" color="secondary" (click)="close()"> {{ 'CALL.MODAL.BUTTON' | translate }}</app-button>
  </div>
</div>
